import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getBillBrandTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'
import { getBillResourceTypeLabel } from '@Bill/utils'
import { getRateRulesColumn } from '../utils/columns'

export default {
  computed: {
    columns () {
      return [
        getNameDescriptionTableColumn({
          field: 'resource_type',
          descField: 'id',
          title: i18n.t('bill.rate.title.resource_type'),
          hideField: true,
          edit: false,
          editDesc: false,
          copyDesc: true,
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{getBillResourceTypeLabel(row.resource_type)}</side-page-trigger>
            )
          },
        }),
        {
          field: 'usage_type',
          title: i18n.t('bill.rate.title.usage_type'),
          formatter: ({ row }) => {
            if (row.usage_type) {
              return i18n.t(`rate_usage_type.${row.usage_type}`) + '(' + row.usage_type + ')'
            } else {
              return '-'
            }
          },
        },
        getBillBrandTableColumn({ title: this.$t('bill.usage_platform'), hideLoading: true, emptyValue: this.$t('bill.text_259') }),
        {
          field: 'spec',
          title: i18n.t('bill.rate.title.spec'),
          width: 100,
          formatter: ({ row }) => {
            let output = ''
            if (row.model) {
              output += i18n.t('bill.rate.title.model') + ': ' + row.model + '\n'
            }
            if (row.spec) {
              for (var k in row.spec) {
                const key = this.$te(`rate_spec_key_map.${k}`) ? this.$t(`rate_spec_key_map.${k}`) : k
                output += key + ': ' + row.spec[k] + '\n'
              }
            }
            if (output) {
              return output
            } else {
              return '-'
            }
          },
        },
        {
          field: 'rate_set',
          title: i18n.t('bill.rate.title.rate_set'),
          width: 100,
          formatter: ({ row }) => {
            if (row.rate_set) {
              return row.rate_set
            } else {
              return '-'
            }
          },
        },
        {
          field: 'precision',
          title: i18n.t('bill.rate.title.precision'),
          width: 100,
          formatter: ({ row }) => {
            if (row.precision) {
              return i18n.t(`rate_precision.${row.precision}`)
            } else {
              return '-'
            }
          },
        },
        {
          field: 'price_type',
          title: i18n.t('bill.rate.title.price_type'),
          width: 100,
          formatter: ({ row }) => {
            if (row.price_type) {
              return i18n.t(`rate_price_type.${row.price_type}`)
            } else {
              return '-'
            }
          },
        },
        getRateRulesColumn(),
        {
          field: 'enable_time',
          title: i18n.t('bill.rate.title.enable_time'),
          width: 140,
          formatter: ({ row }) => {
            if (row.enable_date && row.until_date) {
              return row.enable_date + ' ~ ' + row.until_date
            } else if (row.enable_date) {
              return row.enable_date
            } else {
              return '-'
            }
          },
        },
        getTimeTableColumn(),
      ]
    },
  },
}
